import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './ActionButton.sass';

export const ActionButton = ({
  link,
  title,
  inverted,
  onClick,
  disabled,
  className,
  type,
  icon,
  loading,
}) => {
  const classes = classNames('action-button', {
    inverted,
    [className]: !!className,
  });

  const buttonType = type || (link ? 'button' : 'submit');

  const button = (
    <button disabled={disabled || loading} className={classes} onClick={onClick} type={buttonType}>
      {icon || loading ? (
        <div className="button-content">
          {/* icon should be an SVG component, it can be created with https://react-svgr.com/playground/ 
                it can actually be any component so use with care 
            */}
          {icon && !loading ? <div className="icon-space">{icon}</div> : null}
          {loading ? (
            <CircularProgress className="action-button__loading-spinner" size={20} />
          ) : null}
          <div className="button-title">{loading ? 'Lädt...' : title}</div>
        </div>
      ) : (
        title
      )}
    </button>
  );
  return link && !disabled ? <Link to={link}>{button}</Link> : button;
};

ActionButton.propTypes = {
  link: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  inverted: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.object,
};

ActionButton.defaultProps = {
  link: undefined,
  inverted: false,
  onClick: undefined,
  disabled: false,
  loading: false,
  className: undefined,
  type: undefined,
  icon: undefined,
};
